import { render, staticRenderFns } from "./postRequests.vue?vue&type=template&id=b3f3f048&"
import script from "./postRequests.vue?vue&type=script&lang=js&"
export * from "./postRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports